import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What kinds of healthcare businesses do you buy?",
    a: "We acquire home care agencies, assisted living communities, sober living homes, and career support businesses serving the recently released and adults with special needs. If you're unsure whether you fit, send a quick note — we're happy to take a look.",
  },
  {
    q: "How is the valuation calculated?",
    a: "We typically offer between 3 and 5 times normalized earnings (SDE/EBITDA, depending on size). The exact multiple depends on revenue mix, payor stability, staff retention, licensing, and growth trajectory.",
  },
  {
    q: "What documents will you need?",
    a: "After our initial conversation and a mutual confidentiality agreement, we'll request 3 years of profit & loss statements and 3 years of tax returns. We don't ask for documents up front.",
  },
  {
    q: "Do you require seller financing?",
    a: "No. We have financing already secured through established capital partners, so deals are not contingent on you carrying paper. We can still structure earnouts or transition consulting where it benefits both sides.",
  },
  {
    q: "How long does the process take?",
    a: "Most deals move from initial submission to signed letter of intent within 30–45 days, with closing typically 60–90 days after diligence begins — depending on licensing transfers in your state.",
  },
  {
    q: "Is my information kept confidential?",
    a: "Yes. Submissions are reviewed by a partner, never shared with brokers or third parties, and we sign a mutual NDA before exchanging any financials.",
  },
];

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-[#E6EAE3] border-t border-[#D5DACF]"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <span className="eyebrow">Common questions</span>
          <h2 className="font-serif-display text-4xl md:text-5xl tracking-tight mt-5 text-[#1A2621]">
            Answers before you
            <span className="italic text-[#284A3B]"> ever pick up the phone.</span>
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          data-testid="faq-accordion"
          className="mt-14 divide-y divide-[#D5DACF] border-y border-[#D5DACF]"
        >
          {FAQS.map((item, idx) => (
            <AccordionItem
              key={item.q}
              value={`item-${idx}`}
              data-testid={`faq-item-${idx}`}
              className="border-none"
            >
              <AccordionTrigger
                className="text-left py-6 hover:no-underline font-serif-display text-xl md:text-2xl text-[#1A2621]"
                data-testid={`faq-trigger-${idx}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#4A5D54] text-base md:text-lg leading-relaxed pb-6 max-w-3xl">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
